import axios from "axios";
import qs from "qs";
const api = "/xydapi";


/**
 * 添加转贷产品信息
 * @param {*} value
 * @returns
 */
export function add(value) {
    return axios.post(api + "/zdcp/add", value);
}

export function getByFinanceId(
    productName = null,
    pageNum = null
) {
    return axios.get(api + "/zdcp/getByFinanceId", {
        params: { productName, pageNum }
    });
}

export function getByFinanceId2(
    productName = null,
    financeId = null,
    pageNum = null
) {
    return axios.get(api + "/zdcp/getByFinanceId2", {
        params: { productName, financeId, pageNum }
    });
}

export function getByStatus(
    productName = null,
    pageNum = null,
    status = null,
) {
    return axios.get(api + "/zdcp/getByStatus", {
        params: { productName, pageNum, status }
    });
}

export function getById(
    id = null
) {
    return axios.get(api + "/zdcp/getById", {
        params: { id }
    });
}

export function del(value) {
    return axios.post(api + "/zdcp/del", value);
}

export function update(value) {
    return axios.post(api + "/zdcp/update", value);
}

export function addShxx(value) {
    return axios.post(api + "/zdcp/addShxx", value);
}

export function getShxx(
    productId = null
) {
    return axios.get(api + "/zdcp/getShxx", {
        params: { productId }
    });
}

export function getAll() {
    return axios.get(api + "/zdcp/getAll");
}

export function addZdcpOrder(value) {
    return axios.post(api + "/zdcp/addZdcpOrder", value);
}
export function uploadFile(formData) {
    return axios({
        url: api + "/zdcp/upload",
        method: "post",
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
}

export function getAllOrders() {
    return axios.get(api + "/zdcp/getAllOrders");
}

export function getByOrderStatus(
    productName = null,
    companyName = null,
    pageNum = null,
    status = null,
) {
    return axios.get(api + "/zdcp/getByOrderStatus", {
        params: { productName, companyName, pageNum, status }
    });
}

export function updateOrderStatus(value) {
    return axios.post(api + "/zdcp/updateOrderStatus", value);
}


export function findAllYxdwgl() {
    return axios.get(api + "/zdcp/findAllYxdwgl");
}




